import type {
  Direction,
  LogicalAlignment,
} from '@wix/editor-elements-common-utils';
import { getOppositeAlign } from '@wix/editor-elements-common-utils';

export const reverseAlignmentOnRtl = (
  alignment: LogicalAlignment,
  direction: Direction,
) =>
  alignment !== 'center' && direction === 'rtl'
    ? getOppositeAlign(alignment)
    : alignment;
